"use client";

import { createElement } from "react";
import { InputInfo } from "./InputInfo";
import { Label } from "./Label";
import { cn } from "@repo/shared/utils";
import type { LucideIcon } from "lucide-react";
import { Combobox, type ComboboxProps } from "./Combobox";

export interface ComboboxInputProps extends ComboboxProps {
  id: string;
  label?: string;
  labelStyle?: string;
  containerStyle?: string;
  error?: boolean;
  errorMessage?: string;
  orientation?: "horizontal" | "vertical";
  icon?: LucideIcon;
  inserts?: {
    after?: React.ReactNode;
  };
}

const DynamicIcon = ({ icon }: { icon: LucideIcon }) => {
  return createElement(icon, {
    size: 20,
    className: "absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 transform",
  });
};

export const ComboboxInput = ({
  id,
  label,
  labelStyle,
  containerStyle,
  error,
  errorMessage,
  orientation = "vertical",
  icon,
  inserts,
  ...props
}: ComboboxInputProps) => {
  return (
    <div
      className={cn(
        "flex gap-y-1 mt-1.5",
        orientation === "horizontal"
          ? "flex-row items-center gap-x-3"
          : "flex-col",
        containerStyle
      )}
    >
      {label && <Label className={labelStyle} label={label} id={id} />}
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center relative flex-grow w-full">
          {icon && <DynamicIcon icon={icon} />}
          <Combobox {...props}></Combobox>
          {inserts?.after}
        </div>
        {error && errorMessage && <InputInfo info={errorMessage} />}
      </div>
    </div>
  );
};
